const loadExternalLibrary = async (src, id) => {

    return new Promise((resolve, reject) => {

        const existingScript = document.getElementById(id);
        if (!existingScript) {
            const script = document.createElement('script');
            script.src = src;
            script.id = id;
            document.head.appendChild(script);
            script.onload = () => {
                    resolve()
            };
            script.onabort = () => {
                reject();
            }
        }
        if (existingScript) resolve();

    });
};

export default loadExternalLibrary;